import { Link, Navigate, useParams } from "react-router-dom";
import { Lock } from "lucide-react";
import { GoProButton } from "@/pages/UpgradeDialog";
import { PLANS } from "@/lib/billing";
import { useTeam } from "@/lib/team";

export const LOCKED = {
  create: ["Create", "Snap photos and let AI write full eBay drafts."],
  library: ["Library", "All your drafts in one place, ready to post."],
  listings: ["Listings", "Manage, revise and relist your live eBay listings."],
  dashboard: ["Dashboard", "Sales, profit, sell-through and assistant pay charts."],
  team: ["Team", "Add photo and lister assistants to your account."],
  extension: ["Chrome extension", "Paste-and-go drafts into eBay from your computer."],
};

const PATH_TO_LOCK = { "/": "create", "/library": "library", "/listings": "listings", "/dashboard": "dashboard", "/team": "team", "/extension": "extension", "/queue": "library" };
export const lockFor = (pathname) => PATH_TO_LOCK[pathname];

// Research-plan accounts: a feature outside the plan, with the upgrade options.
export default function LockedPage() {
  const { feature } = useParams();
  const { researchPlan } = useTeam();
  const f = LOCKED[feature];
  if (!researchPlan || !f) return <Navigate to={researchPlan ? "/research" : "/"} replace />;
  return (
    <div className="mx-auto max-w-md space-y-5 py-6 text-center" data-testid={`locked-page-${feature}`}>
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-slate-900 text-white"><Lock className="h-6 w-6" /></div>
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">{f[0]} is locked</h1>
        <p className="mt-2 text-sm text-slate-600">{f[1]}</p>
        <p className="mt-1 text-sm text-slate-600">Your Research plan covers What's it worth, Deep research, media and research batches, alerts and eBay settings. Upgrade to unlock everything.</p>
      </div>
      <div className="space-y-2">
        <GoProButton className="w-full" plan="monthly" label={`Upgrade to Pro — ${PLANS.monthly.price}/mo`} testid="locked-upgrade-pro" />
        <GoProButton className="w-full" plan="yearly" variant="outline" label={`Pro yearly — ${PLANS.yearly.price}/yr (${PLANS.yearly.badge})`} testid="locked-upgrade-yearly" />
        <GoProButton className="w-full" plan="starter" variant="outline" label={`Starter — ${PLANS.starter.price}/mo for 100 drafts`} testid="locked-upgrade-starter" />
      </div>
      <Link to="/billing" className="inline-block text-xs text-slate-500 underline" data-testid="locked-see-plans">See all plans, including Team</Link>
    </div>
  );
}

export function LockedTab({ feature, current }) {
  return (
    <Link to={`/locked/${feature}`} data-testid={`nav-locked-${feature}`} title={`${LOCKED[feature][0]} — upgrade to unlock`}
      className={`flex flex-1 items-center justify-center gap-px whitespace-nowrap rounded-full px-[clamp(1px,0.6vw,4px)] py-1.5 text-center text-[clamp(9px,2.8vw,11px)] transition-colors sm:flex-none sm:gap-1 sm:px-3 sm:text-xs ${current === `locked-${feature}` ? "bg-white text-slate-900 shadow-sm" : "text-slate-400 hover:text-slate-700"}`}>
      <Lock className="h-2 w-2 shrink-0 sm:h-3 sm:w-3" /> {LOCKED[feature][0]}
    </Link>
  );
}
